// extracted by mini-css-extract-plugin
export default {"section":"create_section__KpR+W","error":"create_error__MgD93","send":"create_send__-uB1R"};